module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sk-reset-page"
  }, [_c('div', {
    staticClass: "sk-topbar"
  }, [_c('a', {
    staticClass: "sk-logo",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('img', {
    staticStyle: {
      "height": "48px",
      "width": "auto",
      "display": "block"
    },
    attrs: {
      "src": "https://sentrykit.com/wp-content/uploads/2026/04/Sk-2.0-logo-white.png",
      "alt": "SentryKit"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "sk-main"
  }, [_c('div', {
    staticClass: "sk-card"
  }, [_vm._m(0), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "sk-error-msg"
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "fill": "none",
      "viewBox": "0 0 24 24",
      "stroke": "currentColor"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "10",
      "stroke-width": "2"
    }
  }), _c('path', {
    attrs: {
      "stroke-width": "2",
      "d": "M12 8v4m0 4h.01"
    }
  })]), _vm._v("\n        " + _vm._s(_vm.error) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.message) ? _c('div', {
    staticClass: "sk-success-msg"
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "fill": "none",
      "viewBox": "0 0 24 24",
      "stroke": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      "d": "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
    }
  })]), _vm._v("\n        " + _vm._s(_vm.message) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.resetPassword.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "sk-form-row"
  }, [_c('div', {
    staticClass: "sk-field"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "sk-password-wrap"
  }, [((_vm.showPassword ? 'text' : 'password') === 'checkbox') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "sk-input",
    attrs: {
      "placeholder": "Min. 8 characters",
      "required": "",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.password) ? _vm._i(_vm.password, null) > -1 : (_vm.password)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.password,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.password = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.password = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.password = $$c
        }
      }
    }
  }) : ((_vm.showPassword ? 'text' : 'password') === 'radio') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "sk-input",
    attrs: {
      "placeholder": "Min. 8 characters",
      "required": "",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.password, null)
    },
    on: {
      "change": function($event) {
        _vm.password = null
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "sk-input",
    attrs: {
      "placeholder": "Min. 8 characters",
      "required": "",
      "type": _vm.showPassword ? 'text' : 'password'
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "sk-toggle-pw",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showPassword = !_vm.showPassword
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "fill": "none",
      "viewBox": "0 0 24 24",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  }, [_c('path', {
    attrs: {
      "d": "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
    }
  }), _c('path', {
    attrs: {
      "d": "M2.458 12C3.732 7.943 7.523 5 12 5c4.477 0 8.268 2.943 9.542 7-1.274 4.057-5.065 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
    }
  })])])]), _vm._v(" "), (_vm.password && _vm.passwordWeak) ? _c('div', {
    staticClass: "sk-field-error"
  }, [_vm._v("Must be 8+ characters with a letter and number/symbol")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "sk-form-row sk-mt-4"
  }, [_c('div', {
    staticClass: "sk-field"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "sk-password-wrap"
  }, [((_vm.showPassword2 ? 'text' : 'password') === 'checkbox') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password2),
      expression: "password2"
    }],
    staticClass: "sk-input",
    attrs: {
      "placeholder": "Repeat password",
      "required": "",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.password2) ? _vm._i(_vm.password2, null) > -1 : (_vm.password2)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.password2,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.password2 = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.password2 = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.password2 = $$c
        }
      }
    }
  }) : ((_vm.showPassword2 ? 'text' : 'password') === 'radio') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password2),
      expression: "password2"
    }],
    staticClass: "sk-input",
    attrs: {
      "placeholder": "Repeat password",
      "required": "",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.password2, null)
    },
    on: {
      "change": function($event) {
        _vm.password2 = null
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password2),
      expression: "password2"
    }],
    staticClass: "sk-input",
    attrs: {
      "placeholder": "Repeat password",
      "required": "",
      "type": _vm.showPassword2 ? 'text' : 'password'
    },
    domProps: {
      "value": (_vm.password2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password2 = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "sk-toggle-pw",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showPassword2 = !_vm.showPassword2
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "fill": "none",
      "viewBox": "0 0 24 24",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  }, [_c('path', {
    attrs: {
      "d": "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
    }
  }), _c('path', {
    attrs: {
      "d": "M2.458 12C3.732 7.943 7.523 5 12 5c4.477 0 8.268 2.943 9.542 7-1.274 4.057-5.065 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
    }
  })])])]), _vm._v(" "), (_vm.password2 && _vm.passwordMismatch) ? _c('div', {
    staticClass: "sk-field-error"
  }, [_vm._v("Passwords do not match")]) : _vm._e()])]), _vm._v(" "), _c('button', {
    staticClass: "sk-btn sk-btn-primary sk-mt-6",
    class: {
      loading: _vm.working
    },
    attrs: {
      "type": "submit",
      "disabled": !_vm.isFormValid || _vm.working
    }
  }, [(_vm.working) ? _c('span', {
    staticClass: "sk-spinner"
  }) : _c('span', [_vm._v("Set Password →")])])]), _vm._v(" "), _c('div', {
    staticClass: "sk-login-link"
  }, [_vm._v("Remember your password? "), _c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("Log in")])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sk-card-header"
  }, [_c('h2', [_vm._v("Set a new password")]), _vm._v(" "), _c('p', [_vm._v("Choose a strong password with at least 8 characters.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("New Password "), _c('span', {
    staticClass: "req"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Confirm Password "), _c('span', {
    staticClass: "req"
  }, [_vm._v("*")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-064bffce!./~/vue-loader/lib/selector.js?type=template&index=0!./src/PasswordResetPage.vue
// module id = 718
// module chunks = 2